export default __webpack_public_path__ + "static/media/Gear Icon.3367eb42.svg";